import { Box, styled, Typography } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import star from './assets/trust-star.svg';

const TrustpilotContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  backgroundColor: '#050505',
  background: 'linear-gradient(90deg, #050505 0%, rgba(253, 222, 174, 0) 100%)',
  borderRadius: '100px',
  padding: `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(1.5)}`,
}));

const StarContainer = styled(Box)({
  position: 'relative',
  width: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const StarGlow = styled(Box)({
  position: 'absolute',
  width: 30,
  height: 13.33,
  background: '#FFC87B',
  filter: 'blur(20px)',
  borderRadius: '83.33px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

const Star = styled('img')({
  position: 'relative',
  zIndex: 1,
  fill: '#FFFFFF',
});

const TrustText = styled(Typography)({
  fontSize: 13,
  fontWeight: 400,
  lineHeight: '1.846em',
  letterSpacing: '-0.04em',
  color: '#FFFFFF',
});

const Dot = styled(Box)({
  width: 3,
  height: 3,
  borderRadius: '50%',
  backgroundColor: '#FFFFFF',
});

export function Trustpilot({ companies, turnover }: { companies: number; turnover: string }) {
  const { t } = useTranslation();

  return (
    <TrustpilotContainer>
      <StarContainer>
        <StarGlow />
        <Star src={star} width="20" height="20" />
      </StarContainer>
      <TrustText>
        <b>{t('Trusted by')}</b>
        <span>{t(' {{count}}+ forward-thinking companies', { count: companies })}</span>
      </TrustText>
      <Dot />
      <TrustText>{t('{{turnover}}+ in transactions processed', { turnover })}</TrustText>
    </TrustpilotContainer>
  );
}
